/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * @fileoverview Constants for DNS ip types.
 */

export const IP_TYPE_V4 = 'IPV4';
export const IP_TYPE_V6 = 'IPV6';
export const IP_TYPE_ANY = 'ANYIP';
